// extracted by mini-css-extract-plugin
export default {"loading":"Ep240bcumppZhHb7wIYE"};